import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { editorLocaleResources } from "@tgpe/editor-core";

import en from "../locales/en.json";
import ru from "../locales/ru.json";

const SUPPORTED = ["en", "ru"] as const;
type Supported = (typeof SUPPORTED)[number];

function pickLanguage(code: string | undefined): Supported {
  if (!code) return "en";
  const head = code.toLowerCase().split("-")[0];
  return SUPPORTED.includes(head as Supported) ? (head as Supported) : "en";
}

export function initI18n(languageCode?: string): typeof i18n {
  // Merge editor-core's editor + preview namespaces alongside the Mini App's
  // own translation bundle so editor-core components (LinkEditPopover,
  // FloatingLinkEditor, EmojiPickerPopover, …) render with translated labels.
  void i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en, ...editorLocaleResources.en },
      ru: { translation: ru, ...editorLocaleResources.ru },
    },
    lng: pickLanguage(languageCode),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });
  return i18n;
}

export { i18n };
